import './CowHistory.css'
import { Grid } from '@mui/material'
import React from 'react'
import { format } from 'date-fns'

const UpdateTagContent = ({item}) => {
  return (
    <>
    <Grid className='chContainer' container sx={{
        padding:"10px"
    }}>    
    <Grid className='chDate' item xs={12} textAlign="left">
        {format(new Date(item.CreateDate), "dd MMM yyyy")} 
    </Grid>
    <Grid item xs={12} textAlign="left">
        Tag updated to {item.Detail} on {format(new Date(item.TagDate), "dd MMM yyyy")} 
    </Grid>
    
    </Grid>
    </>
  )
}

export default UpdateTagContent